import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";

import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";
import moment from "moment";
import TablaListEgresos from "./tablaGestionarEgresos";
import CatalogoProveedorPresupuesto from "../../catalogos/catalogoProveedorm";
import { validaSoloNumero, formatMoneda } from "../../util/varios";
import CatalogoCuentaBancaria from "../../catalogos/catalogoCuentasBancarias";
import ValidarUsuario from "../comun/modalValidarUsuario";
import { numeroaLetra } from "../../util/NumeroaLetra";
import {
  Input,
  Radio,
  SearchInput,
  Select,
  Textarea,
} from "../../ui/inputs/Input";
import { DangerButton, InfoButton, SuccessButton, WarningButton } from "../../ui/buttons/Button";
// import { Hidden } from "@mui/material";

export const Egresos = (props) => {
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));
  const anioactu = JSON.parse(localStorage.getItem("anioactu"));
  const anioefi = parseInt(localStorage.getItem("efiscalanio"));
  /* const norden =
    espiritu === 0 || espiritu === 2 || espiritu === 3 || espiritu === 4
      ? false
      : true; */
  const norden = true;

  const [activate, setActivate] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [habiBot, setHabiBot] = useState(false);
  const [habiCta, setHabiCta] = useState(false);
  const [habiCtaDes, setHabiCtaDes] = useState(false);
  const [habiRev, setHabiRev] = useState(false);
  const [activo, setActivo] = useState(true);
  const [operacion, setOperacion] = useState(0);
  const [mostrar4, setMostrar4] = useState(false);
  const [mostrar5, setMostrar5] = useState(false);
  const [datospre, setDatospre] = useState([]);
  const [anio, setAnio] = useState([]);
  const [valida, setValida] = useState(0);
  const [depart, setDepart] = useState(null);
  const [tip, setTip] = useState(null);
  const [ticomp, setTicomp] = useState(null);
  const [ubi, setUbi] = useState(null);
  const [pucc, setPucc] = useState(0);
  const [tituloapro, setTituloapro] = useState("");
  const [data, setData] = useState([]);
  const [body, setBody] = useState(null);
  const [anioOrd, setAnioOrd] = useState(0);
  const [anioOrdArr, setAnioOrdArr] = useState([]);
  const [idCheemi, setIdCheemi] = useState(0);
  const [idCtaBan, setIdCtaBan] = useState("");
  const [modifi, setModifi] = useState(false);
  const [proce, setProce] = useState(false);
  const [modifi1, setModifi1] = useState(false);
  const [proce1, setProce1] = useState(false);
  const [desde, setDesde] = useState(0);
  const [habiConcep, setHabiConcep] = useState(false);
  const [habiFecha, setHabiFecha] = useState(false);
  const [mostrarUsuario, setMostrarUsuario] = useState(false);
  const [cambioDatos, setCambioDatos] = useState(false);
  const [permiEliminar, setPermiEliminar] = useState(0);
  const ip = JSON.parse(localStorage.getItem("ip"));
  const mac = JSON.parse(localStorage.getItem("mac"));
  const [fecha, setFecha] = useState(null);
  const [visibleB, setVisibleB] = useState("hidden");
  const [cuentaBancaria, setCuentaBancaria] = useState();

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [values, setValues] = useState({
    idcuenta: "",
    auxiliar: "",
    descripcionaux: "",
    idcategoriaprogramatica: "",
    idpuc: "",
    puc: "",
    categoria: "",
    disponibilidad: 0.0,
    montoinicial: 0.0,
    tipopartida: "",
  });
  // const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtFecha = useRef();
  const txtIdprov = useRef();
  const txtNp = useRef();
  const txtCodigo = useRef();
  const txtCedurifprov = useRef();
  const txtNombreprov = useRef();
  const txtConcepto = useRef();
  const txtIdCuenta = useRef();
  const txtNomBanco = useRef();
  const txtNumCuenta = useRef();
  const txtNumTransferencia = useRef();
  const cmbAnio = useRef();
  const txtMontoDisponible = useRef();
  const txtMontoPago = useRef();
  const txtMontoRetenciones = useRef();
  const txtMontoAmortizado = useRef();
  const txtMontoPagar = useRef();
  const txtFechaReverso = useRef();
  const txtMotivo = useRef();
  const txtNumReferencia = useRef();

  const cmbGasto = useRef();
  const cmbCuentaBan = useRef();

  const onChange = (e) => {
    if (e.target.id === "anio") {
      /*  if (e.target.value > anioactu) {
         setMensaje({
           mostrar: true,
           titulo: "Notificación",
           texto: "¡El Año no debe ser Mayor a los Anteriores!",
           icono: "error",
         });
         cmbAnio.current.value = "";
         setAnio(0);
       } else { */
      setAnio(e.target.value);
      /*  } */
    } else if (e.target.id === "inputMotivo") {
      e.target.value = e.target.value.toUpperCase();
    }
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtFecha.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Fecha",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (
      (txtNumCuenta.current.value.trim() === "" ||
        txtNomBanco.current.value.trim() === "") && espiritu !== 15
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Favor Seleccione Cuenta Bancaria",
        icono: "informacion",
      });
      sigue = false;
      txtIdCuenta.current.focus();
    } else if (txtNumTransferencia.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Favor Ingrese el Número de Transferencia",
        icono: "informacion",
      });
      sigue = false;
      txtNumTransferencia.current.focus();
    } else if (valida === 0) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Monto a Pagar No Debe Ser Cero(0)",
        icono: "informacion",
      });
      sigue = false;
    } else if (
      parseFloat(
        txtMontoPagar.current.value.replace(/\./g, "").replace(",", ".")
      ) >
      parseFloat(
        txtMontoDisponible.current.value.replace(/\./g, "").replace(",", ".")
      ) && props.operacion === 1
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto:
          "El Monto Disponible en la Cuenta no es Suficiente para Pagar la Orden",
        icono: "informacion",
      });
      sigue = false;
    } else if (props.operacion === 2 && txtMotivo.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Motivo de Reverso No Debe Estar Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtMotivo.current.focus();
    } else if (props.operacion === 2 && txtFechaReverso.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Fecha del Reverso no es valida",
        icono: "informacion",
      });
      sigue = false;
      txtFechaReverso.current.focus();
    } else if (
      visibleB === "visible" && cmbCuentaBan.current.value.trim() === "0" &&
      parseInt(data[0].tipoorden) === 3 &&
      parseInt(data[0].claseorden) === 0 &&
      props.operacion === 1
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Favor Seleccione la Cuenta Destino",
        icono: "informacion",
      });
      sigue = false;
      cmbCuentaBan.current.focus();
    } else if (
      visibleB === "visible" && txtNumReferencia.current.value.trim() === "" &&
      parseInt(data[0].tipoorden) === 3 &&
      parseInt(data[0].claseorden) === 0 &&
      props.operacion === 1
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Favor Ingrese el Número de Referencia ",
        icono: "informacion",
      });
      sigue = false;
      txtNumReferencia.current.focus();
    }

    if (sigue) {
      setBody({
        operacion: props.operacion,
        idegre: props.operacion === 1 ? "0" : txtCodigo.current.value,
        idorden: data[0].idordenpago,
        tipo: 3,
        idcuentaban: txtIdCuenta.current.value,
        numdoc: txtNumTransferencia.current.value,
        ubicacion: props.operacion === 2 ? parseInt(44) : parseInt(48),
        montoegre: parseFloat(
          txtMontoPagar.current.value.replace(/\./g, "").replace(",", ".")
        ),
        fecha: txtFecha.current.value,
        fecharev: txtFechaReverso.current
          ? txtFechaReverso.current.value
          : null,
        motivorev: txtMotivo.current ? txtMotivo.current.value.trim() : null,
        beneficiario: txtNombreprov.current.value.trim(),
        concepto: txtConcepto.current.value.trim(),
        idclasegasto: cmbGasto.current ? cmbGasto.current.value : null,
        idmovibanco:
          props.operacion === 1 ? null : props.movibanco.idmovimientobanco,
        idefi: idefiscal,
        anioefi: anioefi,
        idusuario: idusuario,
        espiritu: espiritu,
        fechasis: fechaSistema,
        dirip: ip === "" || ip === null ? "0.0.0.0" : ip,
        dirmac: mac === "" || mac === null ? "0.0.0.0" : mac,
        datosordenp: data,
        estraslado: visibleB === "visible" ? true : false,
        idcuentaband:
          visibleB === "visible" ? cmbCuentaBan.current.value : null,
        referencia:
          visibleB === "visible" ? txtNumReferencia.current.value : null,
      });

      let msg = "";
      setDesde(0);
      if (props.operacion === 1) {
        msg = "Esta Seguro de Registrar este Egreso?.";
      } else if (props.operacion === 2) {
        msg = "Esta Seguro de Reversar este Egreso?.";
      } else if (props.operacion === 3) {
        msg = "Esta Seguro de Eliminar este Egreso?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/administracion/actualizaregreso`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setIdCheemi(response.data.idegreso);
          if (props.operacion !== 3) {
            ActualizarAsiento(response.data.idegreso);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "El Egreso N° " + txtCodigo.current.value + " fué Eliminado",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const ActualizarAsiento = (idEgreso) => {
    let cad = "",
      cad1 = "",
      cad2 = "",
      cad3 = "",
      cad4 = "",
      cad5 = "",
      cad6 = "",
      numords = "",
      cade2 = "",
      concepto = "",
      sqldebe = "",
      sqlhaber = "";
    let cad7 = "",
      cad8 = "",
      cad9 = "",
      cad10 = "",
      cad11 = "",
      cad12 = "";
    let depter = false,
      repo = false,
      anti = false,
      transfe = false,
      esabono = false,
      primerabono = false,
      reinte = false,
      apertura = false,
      fondo = false,
      cuexpagar = false,
      anticiprovee = false,
      juzgado = false,
      fondoanti = false;
    if (data.length > 1) {
      cad = "(s)";
      cad1 = "(es)";
    } else {
      cad = "";
      cad1 = "";
    }
    for (let i = 0; i < data.length; i++) {
      if (parseInt(data[i].tipoorden) === 3) {
        if (parseInt(data[i].claseorden) === 0 && !depter) {
          cad2 = "Deposito de Terceros";
          depter = true;
        } else if (parseInt(data[i].claseorden) === 1 && !repo) {
          cad3 = "Reposición de Cheque";
          repo = true;
        } else if (parseInt(data[i].claseorden) === 2 && !anti) {
          cad4 = "Anticipo de Obra";
          anti = true;
        } else if (parseInt(data[i].claseorden) === 3 && !transfe) {
          cad5 = "Transferencia Bancaria";
          transfe = true;
        } else if (parseInt(data[i].claseorden) === 4 && !transfe) {
          cad6 = "Reintegro";
          reinte = true;
        } else if (parseInt(data[i].claseorden) === 5 && !transfe) {
          cad7 = "Apertura de Caja Chica";
          apertura = true;
        } else if (parseInt(data[i].claseorden) === 6 && !transfe) {
          cad8 = "Fondo en Avance";
          fondo = true;
        } else if (parseInt(data[i].claseorden) === 7 && !transfe) {
          cad9 = "Cuenta por Pagar";
          cuexpagar = true;
        } else if (parseInt(data[i].claseorden) === 8 && !transfe) {
          cad10 = "Anticipos a Proveedores";
          anticiprovee = true;
        } else if (parseInt(data[i].claseorden) === 9 && !transfe) {
          cad11 = "Juzgado de Menores";
          juzgado = true;
        } else if (parseInt(data[i].claseorden) === 10 && !fondoanti) {
          cad12 = "Fondo en Anticipo";
          fondoanti = true;
        }
      }
      cade2 =
        cad2.trim() +
        (cad3.trim() !== "" ? ", " + cad3 : "") +
        (cad4.trim() !== "" ? ", " + cad4 : "") +
        (cad5.trim() !== "" ? ", " + cad5 : "") +
        (cad6.trim() !== "" ? ", " + cad6 : "") +
        (cad7.trim() !== "" ? ", " + cad7 : "") +
        (cad8.trim() !== "" ? ", " + cad8 : "") +
        (cad9.trim() !== "" ? ", " + cad9 : "") +
        (cad10.trim() !== "" ? ", " + cad10 : "") +
        (cad11.trim() !== "" ? ", " + cad11 : "") +
        (cad12.trim() !== "" ? ", " + cad12 : "");
      cade2 =
        cade2.trim().length > 0
          ? cade2.substring(0, 1) === ","
            ? cade2.substring(1, cade2.length)
            : cade2
          : "";
      numords = numords + (norden ? data[i].numordenpago : data[i].idordenpago);
      if (i < data.length - 1) {
        numords = numords + ", ";
      }
    }
    let montototal = 0.0;
    for (let i = 0; i < data.length; i++) {
      montototal =
        parseFloat(data[i].montoorden) -
        parseFloat(data[i].montoretenido) -
        parseFloat(data[i].montoamortizado);
      montototal = Math.round(montototal * Math.pow(10, 2)) / Math.pow(10, 2);
      if (
        montototal >
        Math.round(data[i].montopagar * Math.pow(10, 2)) / Math.pow(10, 2)
      ) {
        esabono = true;
        if (parseFloat(data[i].montoabonado) > 0.0) {
          primerabono = false;
        } else {
          primerabono = true;
        }
        break;
      } else {
        esabono = false;
      }
    }
    if (operacion === 1) {
      // Asiento Nº 1
      if (esabono) {
        concepto =
          "Para Registrar Abono de la" +
          cad +
          " Orden" +
          cad1 +
          " de Pago" +
          cad +
          ": " +
          numords +
          " Correspondiente al Egreso Nº: " +
          idEgreso +
          " y Cheque Nº: " +
          txtNumTransferencia.current.value.trim() +
          (cade2.trim() === "" ? "" : "(" + cade2 + ")");
        if (primerabono) {
          sqldebe =
            "SELECT idcuentacontable, codigocuenta, descripcion, sum(debe) As debe, 0.00 As haber " +
            "FROM (SELECT ct.idcuentacontable, c.codigocuenta, pc.descripcion, " +
            (espiritu !== 9
              ? Math.round(
                (parseFloat(data[0].montopagar) +
                  parseFloat(data[0].montoretenido)) *
                Math.pow(10, 2)
              ) /
              Math.pow(10, 2) +
              " As debe, "
              : Math.round(parseFloat(data[0].montopagar) * Math.pow(10, 2)) /
              Math.pow(10, 2) +
              " As debe, ") +
            "0.00 As haber FROM cuentacontablextipoordendepago ct, cuentacontable c, plancuenta pc, " +
            "ordenpagoxchequeemitido oc, ordenpago o, compromiso co " +
            "WHERE ct.idcuentacontable = c.idcuentacontable AND ct.idefiscal = " +
            idefiscal +
            " AND c.idplancuenta = pc.idplancuenta AND oc.idordenpago = o.idordenpago AND o.idefiscal = " +
            idefiscal +
            " AND o.idcompromiso = co.idcompromiso AND co.idefiscal = " +
            idefiscal +
            " AND oc.idchequeemitido =  " +
            idEgreso +
            " AND oc.idefiscal = " +
            idefiscal +
            " AND ct.idtipomovimiento = co.tipo " +
            "GROUP BY ct.idcuentacontable, c.codigocuenta, pc.descripcion" +
            " UNION " +
            "SELECT ct.idcuentacontable, c.codigocuenta, pc.descripcion, " +
            (espiritu !== 9
              ? Math.round(
                (parseFloat(data[0].montopagar) +
                  parseFloat(data[0].montoretenido)) *
                Math.pow(10, 2)
              ) /
              Math.pow(10, 2) +
              " As debe, "
              : Math.round(parseFloat(data[0].montopagar) * Math.pow(10, 2)) /
              Math.pow(10, 2) +
              " As debe, ") +
            "0.00 As haber FROM cuentacontablextipoordendepago ct, cuentacontable c, plancuenta pc, " +
            "ordenpagoxchequeemitido oc, ordenpago o, ordenpagoxpagar op " +
            "WHERE ct.idcuentacontable = c.idcuentacontable AND ct.idefiscal = " +
            idefiscal +
            " AND c.idplancuenta = pc.idplancuenta AND oc.idordenpago = o.idordenpago AND o.idefiscal = " +
            idefiscal +
            " AND o.idordenpago = op.idordenpagofina AND op.idefiordenfina = " +
            idefiscal +
            " AND oc.idchequeemitido =  " +
            idEgreso +
            " AND oc.idefiscal = " +
            idefiscal +
            " AND ct.idtipomovimiento = op.tipocompromiso " +
            "GROUP BY ct.idcuentacontable, c.codigocuenta, pc.descripcion" +
            " UNION " +
            "SELECT cf.idcuentacontable, c.codigocuenta, pc.descripcion, " +
            (espiritu !== 9
              ? Math.round(
                (parseFloat(data[0].montopagar) +
                  parseFloat(data[0].montoretenido)) *
                Math.pow(10, 2)
              ) /
              Math.pow(10, 2) +
              " As debe, "
              : Math.round(parseFloat(data[0].montopagar) * Math.pow(10, 2)) /
              Math.pow(10, 2) +
              " As debe, ") +
            "0.00 As haber FROM cuentacontablenotaxfondoavance cf, cuentacontable c, plancuenta pc, " +
            "ordenpagoxchequeemitido oc, ordenpago o, detallefondoavance df " +
            "WHERE cf.idcuentacontable = c.idcuentacontable AND cf.idefiscal = " +
            idefiscal +
            " AND c.idplancuenta = pc.idplancuenta AND oc.idordenpago = o.idordenpago AND o.idefiscal = " +
            idefiscal +
            " AND o.idordenpago = df.idordenpago AND df.idefiscal = " +
            idefiscal +
            " AND oc.idchequeemitido =  " +
            idEgreso +
            " AND oc.idefiscal = " +
            idefiscal +
            " AND cf.idfondo = df.idfondo " +
            "GROUP BY cf.idcuentacontable, c.codigocuenta, pc.descripcion" +
            (transfe === true
              ? " UNION " +
              "SELECT ct.idcuentacontable, c.codigocuenta, pc.descripcion, " +
              (espiritu !== 9
                ? Math.round(
                  (parseFloat(data[0].montopagar) +
                    parseFloat(data[0].montoretenido)) *
                  Math.pow(10, 2)
                ) /
                Math.pow(10, 2) +
                " As debe, "
                : Math.round(
                  parseFloat(data[0].montopagar) * Math.pow(10, 2)
                ) /
                Math.pow(10, 2) +
                " As debe, ") +
              "0.00 As haber FROM cuentacontabletransfexcuentabancaria ct, cuentacontable c, plancuenta pc, " +
              "chequeemitido ch " +
              "WHERE ct.idcuentacontable = c.idcuentacontable AND ct.idefiscal = " +
              idefiscal +
              "AND ch.idcuentabancaria = ct.idcuentabancaria" +
              " AND c.idplancuenta = pc.idplancuenta AND ch.idchequeemitido =  " +
              idEgreso +
              " AND ch.idefiscal = " +
              idefiscal +
              "GROUP BY ct.idcuentacontable, c.codigocuenta, pc.descripcion"
              : "") +
            " UNION " +
            "SELECT c.idcuentacontable, c.codigocuenta, pc.descripcion, " +
            (espiritu !== 9
              ? Math.round(
                (parseFloat(data[0].montopagar) +
                  parseFloat(data[0].montoretenido)) *
                Math.pow(10, 2)
              ) /
              Math.pow(10, 2) +
              " AS debe, 0.00 As haber "
              : Math.round(parseFloat(data[0].montopagar) * Math.pow(10, 2)) /
              Math.pow(10, 2) +
              " As debe, 0.00 As haber ") +
            "FROM cuentacontable c, plancuenta pc, ordenpagoxchequeemitido oc, ordenpago o, " +
            "(SELECT s.idsolicitudpagoobras, s.idobraasignada,sum(montoiva) as debe, oa.idcuentacontable " +
            "FROM anticipoobras a, solicitudpagoobras s, obraasignada oa, ordenpago o, ordenpagoxchequeemitido oc " +
            "Where s.idsolicitudpagoobras = a.idsolicitudpagoobras AND s.idobraasignada = oa.idobraasignada " +
            "AND oc.idordenpago = o.idordenpago AND a.idordenpago = o.idordenpago " +
            "AND o.idefiscal = " +
            idefiscal +
            " AND s.idefiscal = " +
            idefiscal +
            " AND oc.idchequeemitido =  " +
            idEgreso +
            " AND oc.idefiscal = " +
            idefiscal +
            " GROUP BY s.idsolicitudpagoobras, s.idobraasignada, oa.idcuentacontable) AS x " +
            "WHERE c.idcuentacontable = x.idcuentacontable AND pc.idefiscal = " +
            idefiscal +
            " AND c.idplancuenta = pc.idplancuenta AND oc.idordenpago = o.idordenpago AND o.idefiscal = " +
            idefiscal +
            " AND o.tipo = 3 " +
            "AND oc.idchequeemitido =  " +
            idEgreso +
            " AND oc.idefiscal = " +
            idefiscal +
            " GROUP BY c.idcuentacontable, c.codigocuenta, pc.descripcion, x.debe " +
            (espiritu !== 100
              ? " UNION " +
              "SELECT ct.idcuentacontable, c.codigocuenta, pc.descripcion, " +
              Math.round(
                (parseFloat(data[0].montopagar) +
                  parseFloat(data[0].montoretenido)) *
                Math.pow(10, 2)
              ) /
              Math.pow(10, 2) +
              " AS debe, 0.00 As haber " +
              "FROM cuentacontablextiporetencion ct, cuentacontable c, plancuenta pc, " +
              "(Select sum(r.monto) AS monto, r.idtiporetencion " +
              "FROM retenciondetalle r " +
              "WHERE r.idchequeemitido = " +
              idEgreso +
              " AND r.idefiscalchequeemi = " +
              idefiscal +
              " GROUP BY r.idtiporetencion " +
              " UNION " +
              "Select sum(r.monto) AS monto, r.idtiporetencion " +
              "FROM retenciondetalleislr r " +
              "WHERE r.idchequeemitido = " +
              idEgreso +
              " AND r.idefiscalchequeemi = " +
              idefiscal +
              " GROUP BY r.idtiporetencion) AS X " +
              "WHERE ct.idcuentacontable = c.idcuentacontable AND ct.idefiscal = " +
              idefiscal +
              " AND c.idplancuenta = pc.idplancuenta AND ct.idtiporetencion = x.idtiporetencion " +
              "GROUP BY ct.idcuentacontable, c.codigocuenta, pc.descripcion"
              : "") +
            " UNION " +
            "Select ct.idcuentacontabledepoter AS idcuentacontable, c.codigocuenta, pc.descripcion, " +
            (espiritu !== 9
              ? Math.round(
                (parseFloat(data[0].montopagar) +
                  parseFloat(data[0].montoretenido)) *
                Math.pow(10, 2)
              ) /
              Math.pow(10, 2) +
              " AS debe, 0.00 As haber "
              : Math.round(parseFloat(data[0].montopagar) * Math.pow(10, 2)) /
              Math.pow(10, 2) +
              " As debe, 0.00 As haber ") +
            "FROM cuentacontablextiporetencion ct, cuentacontable c, plancuenta pc,	ordenpagoxchequeemitido oc, (" +
            "SELECT r.idretenciondetalle, r.monto, idtiporetencion,f.idordenpago, c.idchequeemitido, ro.idordenpago as ordenfondo " +
            "FROM retencionxorden ro, chequeemitido c, ordenpagoxchequeemitido oc, " +
            "facturaxorden f, retenciondetalle r WHERE c.idchequeemitido = oc.idchequeemitido AND oc.idefiscal = " +
            idefiscal +
            " AND ro.idordenpago = oc.idordenpago AND ro.islr = false " +
            "AND ro.idretenciondetalle = r.idretenciondetalle AND r.idfacturaxorden = f.idfacturaxorden " +
            "AND c.idchequeemitido = " +
            idEgreso +
            " AND c.idefiscal = " +
            idefiscal +
            " AND ro.idefiscal = " +
            idefiscal +
            " UNION " +
            "SELECT r.idretenciondetalleislr as idretenciondetalle, r.monto, idtiporetencion,r.idordenpago, c.idchequeemitido , ro.idordenpago as ordenfondo " +
            "FROM retencionxorden ro, chequeemitido c, ordenpagoxchequeemitido oc, retenciondetalleislr r " +
            "WHERE c.idchequeemitido = oc.idchequeemitido AND oc.idefiscal = " +
            idefiscal +
            " AND ro.idefiscal = " +
            idefiscal +
            " AND ro.idordenpago = oc.idordenpago AND ro.islr = true " +
            "AND ro.idretenciondetalle = r.idretenciondetalleislr " +
            "AND c.idchequeemitido = " +
            idEgreso +
            " AND c.idefiscal = " +
            idefiscal +
            ") AS x " +
            " WHERE ct.idcuentacontabledepoter = c.idcuentacontable AND ct.idefiscal = " +
            idefiscal +
            " AND c.idplancuenta = pc.idplancuenta AND ct.idtiporetencion = x.idtiporetencion " +
            "AND oc.idordenpago = x.ordenfondo AND oc.idchequeemitido =  " +
            idEgreso +
            " AND oc.idefiscal = " +
            idefiscal +
            " GROUP BY ct.idcuentacontabledepoter, c.codigocuenta, pc.descripcion) AS y " +
            "GROUP BY idcuentacontable, codigocuenta, descripcion";

          sqlhaber =
            "SELECT idcuentacontable, codigocuenta, descripcion, 0.00 As debe, sum(haber) As haber " +
            " FROM (" +
            "Select cb.idcuentacontable, c.codigocuenta, pc.descripcion, 0.00 As debe,  " +
            "ch.montocheque As haber FROM cuentacontablexcuentabancaria cb, cuentacontable c, " +
            "plancuenta pc, chequeemitido ch " +
            "WHERE cb.idcuentacontable = c.idcuentacontable AND c.idplancuenta = pc.idplancuenta " +
            "AND ch.idcuentabancaria = cb.idcuentabancaria AND ch.idchequeemitido =  " +
            idEgreso +
            " AND cb.idefiscal = " +
            idefiscal +
            " AND ch.idefiscal = " +
            idefiscal +
            " UNION " +
            "SELECT c.idcuentacontable, c.codigocuenta, pc.descripcion,0.00 As debe, x.haber " +
            "FROM cuentacontable c, plancuenta pc, ordenpagoxchequeemitido oc, ordenpago o, " +
            "(SELECT s.idsolicitudpagoobras, s.idobraasignada,(CASE WHEN a.monto < 1 THEN a.monto *-1 ELSE a.monto END) as haber, oa.idcuentacontable " +
            "FROM anticipoobras a, solicitudpagoobras s, obraasignada oa, ordenpago o, ordenpagoxchequeemitido oc " +
            "Where s.idsolicitudpagoobras = a.idsolicitudpagoobras AND s.idobraasignada = oa.idobraasignada " +
            "AND oc.idordenpago = o.idordenpago" +
            " AND oc.idefiscal = " +
            idefiscal +
            " AND a.idordenpago = o.idordenpago AND o.idefiscal = " +
            idefiscal +
            " AND s.idefiscal = " +
            idefiscal +
            " AND oc.idchequeemitido =  " +
            idEgreso +
            " GROUP BY s.idsolicitudpagoobras, s.idobraasignada, oa.idcuentacontable, a.monto) AS x " +
            "WHERE c.idcuentacontable = x.idcuentacontable AND pc.idefiscal = " +
            idefiscal +
            " AND c.idplancuenta = pc.idplancuenta AND oc.idordenpago = o.idordenpago AND o.idefiscal = " +
            idefiscal +
            " AND o.tipo = 1" +
            "AND oc.idchequeemitido =  " +
            idEgreso +
            " AND oc.idefiscal = " +
            idefiscal +
            " GROUP BY c.idcuentacontable, c.codigocuenta, pc.descripcion, x.haber) AS y " +
            "GROUP BY idcuentacontable, codigocuenta, descripcion " +
            "ORDER BY haber DESC ";
        } else {
          sqldebe =
            "SELECT idcuentacontable, codigocuenta, descripcion, sum(debe) As debe, 0.00 As haber " +
            "FROM (SELECT ct.idcuentacontable, c.codigocuenta, pc.descripcion, " +
            Math.round(parseFloat(data[0].montopagar) * Math.pow(10, 2)) /
            Math.pow(10, 2) +
            " As debe, " +
            "0.00 As haber FROM cuentacontablextipoordendepago ct, cuentacontable c, plancuenta pc, " +
            "ordenpagoxchequeemitido oc, ordenpago o, compromiso co " +
            "WHERE ct.idcuentacontable = c.idcuentacontable AND ct.idefiscal = " +
            idefiscal +
            " AND c.idplancuenta = pc.idplancuenta AND oc.idordenpago = o.idordenpago AND o.idefiscal = " +
            idefiscal +
            " AND o.idcompromiso = co.idcompromiso AND co.idefiscal = " +
            idefiscal +
            " AND oc.idchequeemitido =  " +
            idEgreso +
            " AND oc.idefiscal = " +
            idefiscal +
            " AND ct.idtipomovimiento = co.tipo " +
            "GROUP BY ct.idcuentacontable, c.codigocuenta, pc.descripcion" +
            " UNION " +
            "SELECT ct.idcuentacontable, c.codigocuenta, pc.descripcion, " +
            /*valfor.redondear((monpag+monret),2) + " As debe, " +*/
            Math.round(parseFloat(data[0].montopagar) * Math.pow(10, 2)) /
            Math.pow(10, 2) +
            " As debe, " +
            "0.00 As haber FROM cuentacontablextipoordendepago ct, cuentacontable c, plancuenta pc, " +
            "ordenpagoxchequeemitido oc, ordenpago o, ordenpagoxpagar op " +
            " WHERE ct.idcuentacontable = c.idcuentacontable AND ct.idefiscal = " +
            idefiscal +
            " AND c.idplancuenta = pc.idplancuenta AND oc.idordenpago = o.idordenpago AND o.idefiscal = " +
            idefiscal +
            " AND o.idordenpago = op.idordenpagofina AND op.idefiordenfina = " +
            idefiscal +
            " AND oc.idchequeemitido =  " +
            idEgreso +
            " AND oc.idefiscal = " +
            idefiscal +
            " AND ct.idtipomovimiento = op.tipocompromiso " +
            " GROUP BY ct.idcuentacontable, c.codigocuenta, pc.descripcion" +
            " UNION " +
            "SELECT cf.idcuentacontable, c.codigocuenta, pc.descripcion, " +
            //valfor.redondear((monpag+monret),2) + " As debe, " +
            Math.round(parseFloat(data[0].montopagar) * Math.pow(10, 2)) /
            Math.pow(10, 2) +
            " As debe, " +
            "0.00 As haber FROM cuentacontablenotaxfondoavance cf, cuentacontable c, plancuenta pc, " +
            "ordenpagoxchequeemitido oc, ordenpago o, detallefondoavance df " +
            "WHERE cf.idcuentacontable = c.idcuentacontable AND cf.idefiscal = " +
            idefiscal +
            " AND c.idplancuenta = pc.idplancuenta AND oc.idordenpago = o.idordenpago AND o.idefiscal = " +
            idefiscal +
            " AND o.idordenpago = df.idordenpago AND df.idefiscal = " +
            idefiscal +
            " AND oc.idchequeemitido =  " +
            idEgreso +
            " AND oc.idefiscal = " +
            idefiscal +
            " AND cf.idfondo = df.idfondo " +
            "GROUP BY cf.idcuentacontable, c.codigocuenta, pc.descripcion" +
            (transfe === true
              ? " UNION " +
              "SELECT ct.idcuentacontable, c.codigocuenta, pc.descripcion, " +
              Math.round(parseFloat(data[0].montopagar) * Math.pow(10, 2)) /
              Math.pow(10, 2) +
              " As debe, " +
              "0.00 As haber FROM cuentacontabletransfexcuentabancaria ct, cuentacontable c, plancuenta pc, " +
              "chequeemitido ch " +
              "WHERE ct.idcuentacontable = c.idcuentacontable AND ct.idefiscal = " +
              idefiscal +
              "AND ch.idcuentabancaria = ct.idcuentabancaria" +
              " AND c.idplancuenta = pc.idplancuenta AND ch.idchequeemitido =  " +
              idEgreso +
              " AND ch.idefiscal = " +
              idefiscal +
              "GROUP BY ct.idcuentacontable, c.codigocuenta, pc.descripcion"
              : "") +
            " UNION " +
            "SELECT c.idcuentacontable, c.codigocuenta, pc.descripcion, " +
            Math.round(parseFloat(data[0].montopagar) * Math.pow(10, 2)) /
            Math.pow(10, 2) +
            " AS debe, 0.00 As haber " +
            "FROM cuentacontable c, plancuenta pc, ordenpagoxchequeemitido oc, ordenpago o, " +
            "(SELECT s.idsolicitudpagoobras, s.idobraasignada,sum(montoiva) as debe, oa.idcuentacontable " +
            "FROM anticipoobras a, solicitudpagoobras s, obraasignada oa, ordenpago o, ordenpagoxchequeemitido oc " +
            "Where s.idsolicitudpagoobras = a.idsolicitudpagoobras AND s.idobraasignada = oa.idobraasignada " +
            "AND oc.idordenpago = o.idordenpago" +
            " AND oc.idefiscal = " +
            idefiscal +
            " AND a.idordenpago = o.idordenpago AND o.idefiscal = " +
            idefiscal +
            " AND s.idefiscal = " +
            idefiscal +
            " AND oc.idchequeemitido =  " +
            idEgreso +
            " GROUP BY s.idsolicitudpagoobras, s.idobraasignada, oa.idcuentacontable) AS x " +
            "WHERE c.idcuentacontable = x.idcuentacontable AND pc.idefiscal = " +
            idefiscal +
            " AND c.idplancuenta = pc.idplancuenta AND oc.idordenpago = o.idordenpago AND o.idefiscal = " +
            idefiscal +
            " AND o.tipo = 3 " +
            "AND oc.idchequeemitido =  " +
            idEgreso +
            " AND oc.idefiscal = " +
            idefiscal +
            " GROUP BY c.idcuentacontable, c.codigocuenta, pc.descripcion, x.debe " +
            (espiritu !== 100
              ? " UNION " +
              "SELECT ct.idcuentacontable, c.codigocuenta, pc.descripcion, " +
              Math.round(parseFloat(data[0].montopagar) * Math.pow(10, 2)) /
              Math.pow(10, 2) +
              " As debe, 0.00 As haber " +
              "FROM cuentacontablextiporetencion ct, cuentacontable c, plancuenta pc, " +
              "(Select sum(r.monto) AS monto, r.idtiporetencion " +
              "FROM retenciondetalle r " +
              "WHERE r.idchequeemitido = " +
              idEgreso +
              " AND r.idefiscalchequeemi = " +
              idefiscal +
              " GROUP BY r.idtiporetencion " +
              " UNION " +
              " Select sum(r.monto) AS monto, r.idtiporetencion " +
              " FROM retenciondetalleislr r " +
              " WHERE r.idchequeemitido = " +
              idEgreso +
              " AND r.idefiscalchequeemi = " +
              idefiscal +
              " GROUP BY r.idtiporetencion) AS X " +
              " WHERE ct.idcuentacontable = c.idcuentacontable AND ct.idefiscal = " +
              idefiscal +
              " AND c.idplancuenta = pc.idplancuenta AND ct.idtiporetencion = x.idtiporetencion " +
              " GROUP BY ct.idcuentacontable, c.codigocuenta, pc.descripcion"
              : "") +
            " UNION " +
            "Select ct.idcuentacontabledepoter AS idcuentacontable, c.codigocuenta, pc.descripcion, " +
            Math.round(parseFloat(data[0].montopagar) * Math.pow(10, 2)) /
            Math.pow(10, 2) +
            " As debe, 0.00 As haber " +
            "FROM cuentacontablextiporetencion ct, cuentacontable c, plancuenta pc,	ordenpagoxchequeemitido oc, (" +
            "SELECT r.idretenciondetalle, r.monto, idtiporetencion,f.idordenpago, c.idchequeemitido, ro.idordenpago as ordenfondo " +
            "FROM retencionxorden ro, chequeemitido c, ordenpagoxchequeemitido oc, " +
            "facturaxorden f, retenciondetalle r WHERE c.idchequeemitido = oc.idchequeemitido AND oc.idefiscal = " +
            idefiscal +
            " AND ro.idordenpago = oc.idordenpago AND ro.islr = false " +
            "AND ro.idretenciondetalle = r.idretenciondetalle AND r.idfacturaxorden = f.idfacturaxorden " +
            "AND c.idchequeemitido = " +
            idEgreso +
            "AND c.idefiscal = " +
            idefiscal +
            " AND ro.idefiscal = " +
            idefiscal +
            " UNION " +
            "SELECT r.idretenciondetalleislr as idretenciondetalle, r.monto, idtiporetencion,r.idordenpago, c.idchequeemitido , ro.idordenpago as ordenfondo " +
            "FROM retencionxorden ro, chequeemitido c, ordenpagoxchequeemitido oc, retenciondetalleislr r " +
            "WHERE c.idchequeemitido = oc.idchequeemitido AND oc.idefiscal = " +
            idefiscal +
            " AND ro.idefiscal = " +
            idefiscal +
            " AND ro.idordenpago = oc.idordenpago AND ro.islr = true " +
            "AND ro.idretenciondetalle = r.idretenciondetalleislr " +
            "AND c.idchequeemitido = " +
            idEgreso +
            "AND c.idefiscal = " +
            idefiscal +
            ") AS x " +
            "WHERE ct.idcuentacontabledepoter = c.idcuentacontable AND ct.idefiscal = " +
            idefiscal +
            " AND c.idplancuenta = pc.idplancuenta AND ct.idtiporetencion = x.idtiporetencion " +
            "AND oc.idordenpago = x.ordenfondo AND oc.idchequeemitido =  " +
            idEgreso +
            " AND oc.idefiscal = " +
            idefiscal +
            " GROUP BY ct.idcuentacontabledepoter, c.codigocuenta, pc.descripcion) AS y " +
            "GROUP BY idcuentacontable, codigocuenta, descripcion";

          sqlhaber =
            "SELECT idcuentacontable, codigocuenta, descripcion, 0.00 As debe, sum(haber) As haber " +
            " FROM (" +
            "Select cb.idcuentacontable, c.codigocuenta, pc.descripcion, 0.00 As debe,  " +
            "ch.montocheque As haber FROM cuentacontablexcuentabancaria cb, cuentacontable c, " +
            "plancuenta pc, chequeemitido ch " +
            "WHERE cb.idcuentacontable = c.idcuentacontable AND c.idplancuenta = pc.idplancuenta " +
            "AND ch.idcuentabancaria = cb.idcuentabancaria AND ch.idchequeemitido =  " +
            idEgreso +
            " AND cb.idefiscal = " +
            idefiscal +
            " AND ch.idefiscal = " +
            idefiscal +
            " UNION " +
            "SELECT c.idcuentacontable, c.codigocuenta, pc.descripcion,0.00 As debe, x.haber " +
            "FROM cuentacontable c, plancuenta pc, ordenpagoxchequeemitido oc, ordenpago o, " +
            "(SELECT s.idsolicitudpagoobras, s.idobraasignada,(CASE WHEN a.monto < 1 THEN a.monto *-1 ELSE a.monto END) as haber, oa.idcuentacontable " +
            "FROM anticipoobras a, solicitudpagoobras s, obraasignada oa, ordenpago o, ordenpagoxchequeemitido oc " +
            "Where s.idsolicitudpagoobras = a.idsolicitudpagoobras AND s.idobraasignada = oa.idobraasignada " +
            "AND oc.idordenpago = o.idordenpago" +
            " AND oc.idefiscal = " +
            idefiscal +
            " AND a.idordenpago = o.idordenpago AND o.idefiscal = " +
            idefiscal +
            " AND s.idefiscal = " +
            idefiscal +
            " AND oc.idchequeemitido =  " +
            idEgreso +
            " GROUP BY s.idsolicitudpagoobras, s.idobraasignada, oa.idcuentacontable, a.monto) AS x " +
            "WHERE c.idcuentacontable = x.idcuentacontable AND pc.idefiscal = " +
            idefiscal +
            " AND c.idplancuenta = pc.idplancuenta AND oc.idordenpago = o.idordenpago AND o.idefiscal = " +
            idefiscal +
            " AND o.tipo = 1 " +
            "AND oc.idchequeemitido =  " +
            idEgreso +
            " AND oc.idefiscal = " +
            idefiscal +
            ") AS y " +
            " GROUP BY idcuentacontable, codigocuenta, descripcion, haber " +
            "ORDER BY haber DESC ";
        }
      } else {
        concepto =
          "Para Registrar Pago de la" +
          cad +
          " Orden" +
          cad1 +
          " de Pago" +
          cad +
          ": " +
          numords +
          " Correspondiente al Egreso Nº: " +
          idEgreso +
          " y Cheque Nº: " +
          txtNumTransferencia.current.value.trim() +
          (cade2.trim() === "" ? "" : "(" + cade2 + ")");

        sqldebe =
          "SELECT idcuentacontable, codigocuenta, descripcion, sum(debe) As debe, 0.00 As haber " +
          "FROM (SELECT ct.idcuentacontable, c.codigocuenta, pc.descripcion, " +
          (espiritu !== 9
            ? "sum(o.montoordenpago) As debe, "
            : "ch.montocheque As debe, ") +
          "0.00 As haber FROM cuentacontablextipoordendepago ct, cuentacontable c, plancuenta pc, " +
          "ordenpagoxchequeemitido oc, ordenpago o, compromiso co, chequeemitido ch " +
          "WHERE ct.idcuentacontable = c.idcuentacontable AND ct.idefiscal = " +
          idefiscal +
          " AND c.idplancuenta = pc.idplancuenta AND oc.idordenpago = o.idordenpago AND o.idefiscal = " +
          idefiscal +
          " AND o.idcompromiso = co.idcompromiso AND co.idefiscal = " +
          idefiscal +
          " AND oc.idchequeemitido =  " +
          idEgreso +
          " AND oc.idefiscal = " +
          idefiscal +
          " AND ct.idtipomovimiento = co.tipo AND ch.idchequeemitido = oc.idchequeemitido " +
          " AND ch.idefiscal = " +
          idefiscal +
          " GROUP BY ct.idcuentacontable, c.codigocuenta, pc.descripcion, ch.montocheque" +
          " UNION " +
          "SELECT cf.idcuentacontable, c.codigocuenta, pc.descripcion, " +
          "ch.montocheque As debe, " +
          "0.00 As haber FROM cuentacontablenotaxfondoavance cf, cuentacontable c, plancuenta pc, " +
          "ordenpagoxchequeemitido oc, ordenpago o, detallefondoavance df, chequeemitido ch " +
          "WHERE cf.idcuentacontable = c.idcuentacontable AND cf.idefiscal = " +
          idefiscal +
          " AND c.idplancuenta = pc.idplancuenta AND oc.idordenpago = o.idordenpago AND o.idefiscal = " +
          idefiscal +
          " AND o.idordenpago = df.idordenpago AND df.idefiscal = " +
          idefiscal +
          " AND oc.idchequeemitido =  " +
          idEgreso +
          " AND oc.idefiscal = " +
          idefiscal +
          " AND cf.idfondo = df.idfondo AND ch.idchequeemitido = oc.idchequeemitido " +
          " AND ch.idefiscal = " +
          idefiscal +
          " GROUP BY cf.idcuentacontable, c.codigocuenta, pc.descripcion, ch.montocheque" +
          (transfe === true
            ? " UNION " +
            "SELECT ct.idcuentacontable, c.codigocuenta, pc.descripcion, " +
            "ch.montocheque As debe, " +
            "0.00 As haber FROM cuentacontabletransfexcuentabancaria ct, cuentacontable c, plancuenta pc, " +
            "chequeemitido ch " +
            "WHERE ct.idcuentacontable = c.idcuentacontable AND ct.idefiscal = " +
            idefiscal +
            "AND ch.idcuentabancaria = ct.idcuentabancaria" +
            " AND c.idplancuenta = pc.idplancuenta AND ch.idchequeemitido =  " +
            idEgreso +
            " AND ch.idefiscal = " +
            idefiscal +
            "GROUP BY ct.idcuentacontable, c.codigocuenta, pc.descripcion, ch.montocheque"
            : "") +
          " UNION " +
          "Select cb.idcuentacontable, c.codigocuenta, pc.descripcion, cr.montocheque As debe, 0.00 As haber " +
          "FROM cuentacontablexcuentabancaria cb, cuentacontable c, " +
          "plancuenta pc, chequeemitido ch, ordenpagoxchequeemitido oc, ordenpago o, chequeemitido cr " +
          "WHERE cb.idcuentacontable = c.idcuentacontable AND c.idplancuenta = pc.idplancuenta " +
          "AND cr.idcuentabancaria = cb.idcuentabancaria AND ch.idchequeemitido =  " +
          idEgreso +
          " AND ch.idchequeemitido = oc.idchequeemitido AND oc.idordenpago = o.idordenpago " +
          "AND cr.ordenpago =  o.idordenpago AND o.idefiscal = cr.idefiscal AND o.idefiscal = oc.idefiscal " +
          "AND cb.idefiscal = cr.idefiscal AND ch.idefiscal = " +
          idefiscal +
          " AND o.idefiscal = " +
          idefiscal +
          (espiritu === 100
            ? " UNION " +
            "Select ct.idcuentacontable, c.codigocuenta, pc.descripcion, sum(x.monto) As debe, 0.00 As haber " +
            "FROM cuentacontablextipoordendepago ct, cuentacontable c, plancuenta pc, ordenpago o, compromiso co, " +
            "(Select rd.monto, f.idordenpago, ord.idefiscal " +
            "FROM retenciondetalle rd, chequeemitido ch, ordenpagoxchequeemitido oc, ordenpago o, facturaxorden f, ordenpago ord " +
            "WHERE ch.idchequeemitido =  " +
            idEgreso +
            " AND ch.idchequeemitido = oc.idchequeemitido " +
            "AND oc.idordenpago = o.idordenpago AND ch.idefiscal = oc.idefiscal AND o.idefiscal = oc.idefiscal " +
            "AND ch.idefiscal = " +
            idefiscal +
            " AND rd.idefiscal = " +
            idefiscal +
            " AND rd.ordenpagoaprob = oc.idordenpago " +
            "AND rd.idfacturaxorden = f.idfacturaxorden AND rd.idefiscal = ord.idefiscal " +
            "AND f.idordenpago = ord.idordenpago AND rd.idefiscal = f.idefiscal " +
            " UNION " +
            "Select rd.monto, f.idordenpago, ord.idefiscal " +
            "FROM retenciondetalle rd, chequeemitido ch, ordenpagoxchequeemitido oc, ordenpago o, facturaxorden f, ordenpago ord " +
            "WHERE ch.idchequeemitido =  " +
            idEgreso +
            " AND ch.idchequeemitido = oc.idchequeemitido " +
            "AND oc.idordenpago = o.idordenpago AND ch.idefiscal = oc.idefiscal AND o.idefiscal = oc.idefiscal " +
            "AND ch.idefiscal = " +
            idefiscal +
            " AND rd.idefiscal = " +
            (idefiscal - 1) +
            " AND rd.ordenpagoaprob = oc.idordenpago " +
            "AND rd.idfacturaxorden = f.idfacturaxorden AND rd.idefiscal = ord.idefiscal " +
            "AND f.idordenpago = ord.idordenpago AND rd.idefiscal = f.idefiscal " +
            " UNION " +
            "Select rd.monto, rd.idordenpago, ord.idefiscal " +
            "FROM retenciondetalleislr rd, chequeemitido ch, ordenpagoxchequeemitido oc, ordenpago o, ordenpago ord " +
            "WHERE ch.idchequeemitido =  " +
            idEgreso +
            " AND ch.idchequeemitido = oc.idchequeemitido " +
            "AND oc.idordenpago = o.idordenpago AND ch.idefiscal = oc.idefiscal AND o.idefiscal = oc.idefiscal " +
            "AND ch.idefiscal = " +
            idefiscal +
            " AND rd.idefiscal = " +
            idefiscal +
            " AND rd.ordenpagoaprob = oc.idordenpago " +
            "AND rd.idordenpago = ord.idordenpago AND rd.idefiscal = ord.idefiscal" +
            " UNION " +
            "Select rd.monto, rd.idordenpago, ord.idefiscal " +
            "FROM retenciondetalleislr rd, chequeemitido ch, ordenpagoxchequeemitido oc, ordenpago o, ordenpago ord " +
            "WHERE ch.idchequeemitido =  " +
            idEgreso +
            " AND ch.idchequeemitido = oc.idchequeemitido " +
            "AND oc.idordenpago = o.idordenpago AND ch.idefiscal = oc.idefiscal AND o.idefiscal = oc.idefiscal " +
            "AND ch.idefiscal = " +
            idefiscal +
            " AND rd.idefiscal = " +
            (idefiscal - 1) +
            " AND rd.ordenpagoaprob = oc.idordenpago " +
            "AND rd.idordenpago = ord.idordenpago AND rd.idefiscal = ord.idefiscal) AS x " +
            "WHERE ct.idcuentacontable = c.idcuentacontable AND ct.idefiscal = " +
            idefiscal +
            " AND c.idplancuenta = pc.idplancuenta " +
            "AND o.idordenpago = x.idordenpago AND o.idefiscal = x.idefiscal " +
            "AND o.idcompromiso = co.idcompromiso AND co.idefiscal = o.idefiscal AND ct.idtipomovimiento = co.tipo " +
            "GROUP BY ct.idcuentacontable, c.codigocuenta, pc.descripcion "
            : "") +
          " UNION " +
          "SELECT ct.idcuentacontable, c.codigocuenta, pc.descripcion, " +
          (espiritu !== 9
            ? "sum(o.montoordenpago) As debe, "
            : "ch.montocheque As debe, ") +
          "0.00 As haber FROM cuentacontablextipoordendepago ct, cuentacontable c, plancuenta pc, " +
          "ordenpagoxchequeemitido oc, ordenpago o, ordenpagoxpagar op, chequeemitido ch " +
          "WHERE ct.idcuentacontable = c.idcuentacontable AND ct.idefiscal = " +
          idefiscal +
          " AND c.idplancuenta = pc.idplancuenta AND oc.idordenpago = o.idordenpago AND o.idefiscal = " +
          idefiscal +
          " AND o.idordenpago = op.idordenpagofina AND op.idefiordenfina = " +
          idefiscal +
          " AND oc.idchequeemitido =  " +
          idEgreso +
          " AND oc.idefiscal = " +
          idefiscal +
          " AND ct.idtipomovimiento = op.tipocompromiso AND ch.idchequeemitido = oc.idchequeemitido " +
          "AND ch.idefiscal = " +
          idefiscal +
          " GROUP BY ct.idcuentacontable, c.codigocuenta, pc.descripcion, ch.montocheque" +
          " UNION " +
          "SELECT c.idcuentacontable, c.codigocuenta, pc.descripcion, x.debe, 0.00 As haber " +
          "FROM cuentacontable c, plancuenta pc, ordenpagoxchequeemitido oc, ordenpago o, " +
          "(SELECT s.idsolicitudpagoobras, s.idobraasignada, " +
          (espiritu !== 9
            ? "sum(montoiva) as debe, "
            : "ch.montocheque As debe, ") +
          "oa.idcuentacontable " +
          "FROM anticipoobras a, solicitudpagoobras s, obraasignada oa, ordenpago o, ordenpagoxchequeemitido oc, chequeemitido ch " +
          "Where s.idsolicitudpagoobras = a.idsolicitudpagoobras AND s.idobraasignada = oa.idobraasignada " +
          "AND oc.idordenpago = o.idordenpago" +
          " AND oc.idefiscal = " +
          idefiscal +
          " AND a.idordenpago = o.idordenpago AND o.idefiscal = " +
          idefiscal +
          " AND s.idefiscal = " +
          idefiscal +
          " AND oc.idchequeemitido =  " +
          idEgreso +
          "  AND ch.idchequeemitido = oc.idchequeemitido " +
          "AND ch.idefiscal = " +
          idefiscal +
          " GROUP BY s.idsolicitudpagoobras, s.idobraasignada, oa.idcuentacontable, ch.montocheque) AS x " +
          "WHERE c.idcuentacontable = x.idcuentacontable AND pc.idefiscal = " +
          idefiscal +
          " AND c.idplancuenta = pc.idplancuenta AND oc.idordenpago = o.idordenpago AND o.idefiscal = " +
          idefiscal +
          " AND o.tipo = 3 " +
          "AND oc.idchequeemitido =  " +
          idEgreso +
          " AND oc.idefiscal = " +
          idefiscal +
          " GROUP BY c.idcuentacontable, c.codigocuenta, pc.descripcion, x.debe " +
          (espiritu !== 100
            ? " UNION " +
            "SELECT ct.idcuentacontable, c.codigocuenta, pc.descripcion, sum(x.monto) As debe, 0.00 As haber " +
            "FROM cuentacontablextiporetencion ct, cuentacontable c, plancuenta pc, " +
            "(Select sum(r.monto) AS monto, r.idtiporetencion " +
            "FROM retenciondetalle r " +
            "WHERE r.idchequeemitido = " +
            idEgreso +
            " AND r.idefiscalchequeemi = " +
            idefiscal +
            " GROUP BY r.idtiporetencion " +
            "UNION " +
            "Select sum(r.monto) AS monto, r.idtiporetencion " +
            "FROM retenciondetalleislr r " +
            "WHERE r.idchequeemitido = " +
            idEgreso +
            " AND r.idefiscalchequeemi = " +
            idefiscal +
            " GROUP BY r.idtiporetencion) AS X " +
            "WHERE ct.idcuentacontable = c.idcuentacontable AND ct.idefiscal = " +
            idefiscal +
            " AND c.idplancuenta = pc.idplancuenta AND ct.idtiporetencion = x.idtiporetencion " +
            "GROUP BY ct.idcuentacontable, c.codigocuenta, pc.descripcion"
            : "") +
          " UNION " +
          "Select ct.idcuentacontabledepoter AS idcuentacontable, c.codigocuenta, pc.descripcion, sum(x.monto) As debe, 0.00 As haber " +
          "FROM cuentacontablextiporetencion ct, cuentacontable c, plancuenta pc,	ordenpagoxchequeemitido oc, (" +
          "SELECT r.idretenciondetalle, r.monto, idtiporetencion,f.idordenpago, c.idchequeemitido, ro.idordenpago as ordenfondo " +
          "FROM retencionxorden ro, chequeemitido c, ordenpagoxchequeemitido oc, " +
          "facturaxorden f, retenciondetalle r WHERE c.idchequeemitido = oc.idchequeemitido AND ro.idordenpago = oc.idordenpago" +
          " AND oc.idefiscal = " +
          idefiscal +
          " AND ro.islr = false " +
          "AND ro.idretenciondetalle = r.idretenciondetalle AND r.idfacturaxorden = f.idfacturaxorden " +
          "AND c.idchequeemitido = " +
          idEgreso +
          " AND c.idefiscal = " +
          idefiscal +
          " AND ro.idefiscal = " +
          idefiscal +
          " UNION " +
          "SELECT r.idretenciondetalleislr as idretenciondetalle, r.monto, idtiporetencion,r.idordenpago, c.idchequeemitido , ro.idordenpago as ordenfondo " +
          "FROM retencionxorden ro, chequeemitido c, ordenpagoxchequeemitido oc, retenciondetalleislr r " +
          "WHERE c.idchequeemitido = oc.idchequeemitido AND ro.idordenpago = oc.idordenpago" +
          " AND oc.idefiscal = " +
          idefiscal +
          " AND ro.islr = true " +
          " AND ro.idefiscal = " +
          idefiscal +
          " AND ro.idretenciondetalle = r.idretenciondetalleislr " +
          "AND c.idchequeemitido = " +
          idEgreso +
          " AND c.idefiscal = " +
          idefiscal +
          ") AS x " +
          "WHERE ct.idcuentacontabledepoter = c.idcuentacontable AND ct.idefiscal = " +
          idefiscal +
          " AND c.idplancuenta = pc.idplancuenta AND ct.idtiporetencion = x.idtiporetencion " +
          "AND oc.idordenpago = x.ordenfondo AND oc.idchequeemitido =  " +
          idEgreso +
          " AND oc.idefiscal = " +
          idefiscal +
          " GROUP BY ct.idcuentacontabledepoter, c.codigocuenta, pc.descripcion) AS y " +
          "GROUP BY idcuentacontable, codigocuenta, descripcion";

        sqlhaber =
          "SELECT idcuentacontable, codigocuenta, descripcion, 0.00 As debe, sum(haber) As haber " +
          " FROM (" +
          "Select cb.idcuentacontable, c.codigocuenta, pc.descripcion, 0.00 As debe,  " +
          "ch.montocheque As haber FROM cuentacontablexcuentabancaria cb, cuentacontable c, " +
          "plancuenta pc, chequeemitido ch " +
          "WHERE cb.idcuentacontable = c.idcuentacontable AND c.idplancuenta = pc.idplancuenta " +
          "AND ch.idcuentabancaria = cb.idcuentabancaria AND ch.idchequeemitido =  " +
          idEgreso +
          " AND cb.idefiscal = " +
          idefiscal +
          " AND ch.idefiscal = " +
          idefiscal +
          (espiritu !== 9
            ? " UNION " +
            "SELECT c.idcuentacontable, c.codigocuenta, pc.descripcion,0.00 As debe, x.haber " +
            "FROM cuentacontable c, plancuenta pc, ordenpagoxchequeemitido oc, ordenpago o, " +
            "(SELECT s.idsolicitudpagoobras, s.idobraasignada,(CASE WHEN a.monto < 1 THEN a.monto *-1 ELSE a.monto END) as haber, oa.idcuentacontable " +
            "FROM anticipoobras a, solicitudpagoobras s, obraasignada oa, ordenpago o, ordenpagoxchequeemitido oc " +
            "Where s.idsolicitudpagoobras = a.idsolicitudpagoobras AND s.idobraasignada = oa.idobraasignada " +
            "AND oc.idordenpago = o.idordenpago" +
            " AND oc.idefiscal = " +
            idefiscal +
            " AND a.idordenpago = o.idordenpago AND o.idefiscal = " +
            idefiscal +
            " AND s.idefiscal = " +
            idefiscal +
            " AND oc.idchequeemitido =  " +
            idEgreso +
            " GROUP BY s.idsolicitudpagoobras, s.idobraasignada, oa.idcuentacontable, a.monto) AS x " +
            "WHERE c.idcuentacontable = x.idcuentacontable AND pc.idefiscal = " +
            idefiscal +
            " AND c.idplancuenta = pc.idplancuenta AND oc.idordenpago = o.idordenpago AND o.idefiscal = " +
            idefiscal +
            " AND o.tipo = 1 " +
            "AND oc.idchequeemitido =  " +
            idEgreso +
            " AND oc.idefiscal = " +
            idefiscal +
            " GROUP BY c.idcuentacontable, c.codigocuenta, pc.descripcion, x.haber " +
            " UNION " +
            "Select ct.idcuentacontable, c.codigocuenta, pc.descripcion, 0.00 As debe, " +
            "x.monto As haber " +
            "FROM cuentacontablextiporetencion ct, cuentacontable c, plancuenta pc, ordenpagoxchequeemitido oc, " +
            "(SELECT sum(r.monto) AS monto, idtiporetencion, c.idchequeemitido " +
            "FROM chequeemitido c, ordenpagoxchequeemitido oc, facturaxorden f, " +
            "retenciondetalle r " +
            "WHERE c.idchequeemitido = oc.idchequeemitido " +
            "AND r.idfacturaxorden = f.idfacturaxorden AND oc.idordenpago = f.idordenpago " +
            " AND oc.idefiscal = " +
            idefiscal +
            " AND c.idchequeemitido = " +
            idEgreso +
            " AND c.idefiscal = " +
            idefiscal +
            " AND r.idefiscal = " +
            idefiscal +
            " GROUP BY idtiporetencion, c.idchequeemitido" +
            " UNION " +
            "SELECT sum(r.monto) AS monto, idtiporetencion, c.idchequeemitido " +
            "FROM  chequeemitido c, ordenpagoxchequeemitido oc, retenciondetalleislr r " +
            "WHERE c.idchequeemitido = oc.idchequeemitido AND oc.idordenpago = r.idordenpago " +
            " AND oc.idefiscal = " +
            idefiscal +
            " AND c.idchequeemitido = " +
            idEgreso +
            " AND c.idefiscal = " +
            idefiscal +
            " AND r.idefiscal = " +
            idefiscal +
            " GROUP BY idtiporetencion, c.idchequeemitido) AS x " +
            "WHERE ct.idcuentacontable = c.idcuentacontable AND ct.idefiscal = " +
            idefiscal +
            " AND c.idplancuenta = pc.idplancuenta AND ct.idtiporetencion = x.idtiporetencion " +
            "AND oc.idchequeemitido =  " +
            idEgreso +
            " AND oc.idefiscal = " +
            idefiscal
            : "") +
          ") AS y " +
          "GROUP BY idcuentacontable, codigocuenta, descripcion " +
          "ORDER BY haber DESC ";
      }
    } else {
      sqldebe = "";
      sqlhaber = "";
      if (esabono) {
        concepto =
          "Para Registrar Reverso de Abono de la" +
          cad +
          " Orden" +
          cad1 +
          " de Pago" +
          cad +
          ": " +
          numords +
          " Correspondiente al Egreso Nº: " +
          txtCodigo.current.value.trim() +
          " y Cheque Nº: " +
          txtNumTransferencia.current.value.trim();
      } else {
        concepto =
          "Para Registrar Reverso de Pago de la" +
          cad +
          " Orden" +
          cad1 +
          " de Pago" +
          cad +
          ": " +
          numords +
          " Correspondiente al Egreso Nº: " +
          txtCodigo.current.value.trim() +
          " y Cheque Nº: " +
          txtNumTransferencia.current.value.trim();
      }
    }

    let body = {
      operacion: props.operacion,
      idegreso: idEgreso,
      descripcion: concepto,
      fecegre: txtFecha.current.value,
      fecharev: txtFechaReverso.current ? txtFechaReverso.current.value : null,
      idefi: idefiscal,
      anioefi: anioefi,
      sqldebe: sqldebe,
      sqlhaber: sqlhaber,
    };
    let endpoint = `${op.conexion}/api/administracion/asientoegreso`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (visibleB === "visible") {
            ActualizarAsientoNotaCredito(idEgreso);
          } else {
            if (props.operacion === 1) {
              //setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Compromiso Registrado Correctamente', icono: 'exito' });
              setDesde(2);
              setMensajesino({
                mostrar: true,
                titulo: "Confirmación.",
                texto: "Desea Imprimir En este Momento Comprobante de Egreso?",
                icono: "confirmacion",
              });
            } else if (props.operacion === 2) {
              setMensaje({
                mostrar: true,
                titulo: "Exito.",
                texto:
                  "El Egreso N° " + txtCodigo.current.value + " fué Reversado",
                icono: "exito",
              });
            } else if (props.operacion === 3) {
              setMensaje({
                mostrar: true,
                titulo: "Exito.",
                texto:
                  "El Egreso N° " + txtCodigo.current.value + " fué Eliminado",
                icono: "exito",
              });
            }
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else {
          if (error.response.data.message === "Asiento no generado.") {
            mensaje = "Asiento no generado.";
            setActivate(false);
            if (visibleB === "visible") {
              ActualizarAsientoNotaCredito(idEgreso);
            } else {
              if (props.operacion === 1) {
                //setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Compromiso Registrado Correctamente', icono: 'exito' });
                setDesde(2);
                setMensajesino({
                  mostrar: true,
                  titulo: "Confirmación.",
                  texto:
                    "Desea Imprimir En este Momento Comprobante de Egreso?",
                  icono: "confirmacion",
                });
              } else if (props.operacion === 2) {
                setMensaje({
                  mostrar: true,
                  titulo: "Exito.",
                  texto:
                    "El Egreso N° " +
                    txtCodigo.current.value +
                    " fué Reversado",
                  icono: "exito",
                });
              } else if (props.operacion === 3) {
                setMensaje({
                  mostrar: true,
                  titulo: "Exito.",
                  texto:
                    "El Egreso N° " +
                    txtCodigo.current.value +
                    " fué Eliminado",
                  icono: "exito",
                });
              }
              return;
            }
          } else {
            setDesde(8);
            mensaje = error.response.data.message;
            /* setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: mensaje,
              }); */
          } 
        }
        /* setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        }); */
        setActivate(false);
      });
  };

  const ActualizarAsientoNotaCredito = (idEgreso) => {
    let body = {
      operacion: props.operacion,
      idegreso: idEgreso,
      fecegre: txtFecha.current.value,
      idcuenta: cmbCuentaBan.current.value,
      referencia: txtNumReferencia.current.value,
      idefi: idefiscal,
      fecharev: txtFechaReverso.current ? txtFechaReverso.current.value : null,
    };
    let endpoint = `${op.conexion}/api/administracion/asientonotacreditoegreso`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (props.operacion === 1) {
            //setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Compromiso Registrado Correctamente', icono: 'exito' });
            setDesde(2);
            setMensajesino({
              mostrar: true,
              titulo: "Confirmación.",
              texto: "Desea Imprimir En este Momento Comprobante de Egreso?",
              icono: "confirmacion",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "El Egreso N° " + txtCodigo.current.value + " fué Reversado",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "El Egreso N° " + txtCodigo.current.value + " fué Eliminado",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else {
          if (error.response.data.message === "Asiento no generado.") {
            mensaje = "Asiento no generado.";
            setActivate(false);
            if (props.operacion === 1) {
              //setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Compromiso Registrado Correctamente', icono: 'exito' });
              setDesde(2);
              setMensajesino({
                mostrar: true,
                titulo: "Confirmación.",
                texto: "Desea Imprimir En este Momento Comprobante de Egreso?",
                icono: "confirmacion",
              });
            } else if (props.operacion === 2) {
              setMensaje({
                mostrar: true,
                titulo: "Exito.",
                texto:
                  "El Egreso N° " + txtCodigo.current.value + " fué Reversado",
                icono: "exito",
              });
            } else if (props.operacion === 3) {
              setMensaje({
                mostrar: true,
                titulo: "Exito.",
                texto:
                  "El Egreso N° " + txtCodigo.current.value + " fué Eliminado",
                icono: "exito",
              });
            }
            return;
          } else {
            setDesde(8);
            mensaje = error.response.data.message;
            /* setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: mensaje,
              }); */
          }
        }
        /* setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        }); */
        setActivate(false);
      });
  };

  const cancelar = () => {
    if (cambioDatos) {
      blanquear();
      props.onHideRenderizar();
      props.onHideCancelar();
    } else {
      blanquear();
      props.onHideCancelar();
    }
  };

  const blanquear = () => {
    setValues({
      idcuenta: "",
      auxiliar: "",
      descripcionaux: "",
      idcategoriaprogramatica: "",
      idpuc: "",
      puc: "",
      categoria: "",
      disponibilidad: 0.0,
      montoinicial: 0.0,
      tipopartida: "",
    });
    setDatospre([]);
    setActivate(false);
    setIdCtaBan("");
    setValida(0);
    setDepart(null);
    setTip(null);
    setUbi(null);
    setPucc(0);
    setData([]);
    setTicomp(null);
    setBody(null);
    setAnio(0);
    setTituloapro("");
    setActivo(true);
    setModifi(false);
    setProce(false);
    setModifi1(false);
    setProce1(false);
    setHabiCta(false);
    setCambioDatos(false);
    setCuentaBancaria();
    setVisibleB("hidden");
    setHabiCtaDes(false);
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (desde === 1) {
      //procesarCambioFechaReverso();
    } else if (desde === 2) {
      imprimirEgreso(idCheemi);
      setMensaje({
        mostrar: true,
        titulo: "Exito.",
        texto: "El Egreso Nª" + idCheemi + " fué Registrado Correctamente",
        icono: "exito",
      });
    } else if (desde === 3) {
      imprimirEgreso(idCheemi);
      setMensaje({
        mostrar: true,
        titulo: "Exito.",
        texto: "Egreso Registrado Correctamente",
        icono: "exito",
      });
    } else if (desde === 4) {
      procesarCambioAutorizacion();
    } else {
      Actualizar();
    }
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideRenderizar();
    props.onHideCancelar();
    blanquear();
  };

  const cerrarMensaje = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (desde === 8) {
      if (props.operacion === 1) {
        //setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Compromiso Registrado Correctamente', icono: 'exito' });
        setDesde(2);
        setMensajesino({
          mostrar: true,
          titulo: "Confirmación.",
          texto: "Desea Imprimir En este Momento Comprobante de Egreso?",
          icono: "confirmacion",
        });
      } else if (props.operacion === 2) {
        setMensaje({
          mostrar: true,
          titulo: "Exito.",
          texto: "El Egreso N° " + txtCodigo.current.value + " fué Reversado",
          icono: "exito",
        });
      } else if (props.operacion === 3) {
        setMensaje({
          mostrar: true,
          titulo: "Exito.",
          texto: "El Egreso N° " + txtCodigo.current.value + " fué Eliminado",
          icono: "exito",
        });
      }
    }
  };

  const BaseDatos = (data, idcta, ope) => {
    if (data.length > 0) {
      setActivo(false);
      setValida(1);
      if (parseInt(idcta) > 0) {
        txtIdCuenta.current.value = idcta;
        seleccionarCuentaBancaria(idcta);
        setHabiCta(false);
      } else {
        setHabiCta(true);
      }
      if (
        parseInt(data[0].tipoorden) === 3 &&
        parseInt(data[0].claseorden) === 0
      ) {
        setVisibleB("visible");
        setHabiCtaDes(true);
        selectCuentaBanco();
      } else {
        setVisibleB("hidden");
        setHabiCtaDes(false);
      }
      //cargarConcepto(data);
      if (ope === 1) {
        setMensaje({
          mostrar: true,
          titulo: "Exito",
          texto: "¡La Orden de Pago fue Incluida!",
          icono: "exito",
        });
      }
      calcularTotales(data);
    } else {
      setActivo(true);
      setValida(0);

      setHabiCta(false);
      setIdCtaBan("");
      txtIdCuenta.current.value = "";
      txtNomBanco.current.value = "";
      txtNumCuenta.current.value = "";
      txtNumTransferencia.current.value = "";
      txtMontoDisponible.current.value = "";
      if (cmbCuentaBan.current) {
        cmbCuentaBan.current.value = "0";
      }
      if (txtNumReferencia.current) {
        txtNumReferencia.current.value = "";
      }
      
      setVisibleB("hidden");
      txtMontoPagar.current.value = "0.00";
      txtMontoAmortizado.current.value = "0.00";
      txtMontoPago.current.value = "0.00";
      txtMontoRetenciones.current.value = "0.00";
    }
    cargarConcepto(data);
    setData(data);
  };

  const selectCuentaBanco = () => {
    let campos = "*";
    let nomtab = "cuentabancaria";
    let condi = "tipo = 'Fondos a Terceros'";
    let orden = "idcuentabancaria";

    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

    /*         console.log(endpoint) */
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setActivate(false);
          if (response.data.length > 0) {
            const newArr = response.data.map((item, index) => {
              return { value: item.idcuentabancaria, label: item.nombre + " " + item.cuentabancaria };
            });
            setCuentaBancaria(newArr);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const calcularTotales = (data) => {
    let totRete = parseFloat("0.00");
    let totAmorti = parseFloat("0.00");
    let totPagar = parseFloat("0.00");
    let totOrd = parseFloat("0.00");
    for (let i = 0; i < data.length; i++) {
      totPagar += parseFloat(data[i].montopagar);
      totRete += parseFloat(data[i].montoretenido);
      totAmorti += parseFloat(data[i].montoamortizado);
      totOrd += parseFloat(data[i].montoorden);
    }
    txtMontoPago.current.value = formatMoneda(
      totOrd.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
    txtMontoRetenciones.current.value = formatMoneda(
      totRete.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
    txtMontoAmortizado.current.value = formatMoneda(
      totAmorti.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
    txtMontoPagar.current.value = formatMoneda(
      totPagar.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
  };

  const handleInputNumChange = (event) => {
    //setActiveIndex(1);
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.which === 13) {
        if (event.target.id === "idprov") {
          if (txtCedurifprov.current.value.trim() !== "") {
            txtConcepto.current.focus();
          }
        } else if (event.target.id === "idcuenta") {
          txtIdCuenta.current.focus();
        } else if (event.target.id === "numtransferencia") {
          if (visibleB === `visible`) {
            cmbCuentaBan.current.focus();
          } else {
            btnAcepta.current.focus();
          }
        } else if (event.target.id === "numReferencia") {
          btnAcepta.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const seleccionarProveedor = (codigo, tecla) => {
    let campos = "*";
    let nomtab = "proveedor";
    let nomid = "idproveedor";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${codigo}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idproveedor > 0) {
            txtIdprov.current.value = response.data.idproveedor;
            txtCedurifprov.current.value = response.data.rif;
            txtNombreprov.current.value = response.data.razonsocial;
            if (props.operacion === 1) {
              setHabiBot(false);
            } else {
              setHabiBot(true);
            }
            if (tecla === 13) {
              txtConcepto.current.focus();
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Error.",
              texto: "¡Código i/o Proveedor/Beneficiario, No esta Registrado!",
              icono: "error",
            });
            txtIdprov.current.value = "";
            txtCedurifprov.current.value = "";
            txtNombreprov.current.value = "";
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const seleccionarCuentaBancaria = (codigo) => {
    let campos = "*";
    let nomtab = "cuentabancaria";
    let nomid = "idcuentabancaria";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${codigo}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idcuentabancaria > 0) {
            if (response.data.status === 2) {
              setMensaje({
                mostrar: true,
                titulo: "Error.",
                texto: "¡La Cuenta Bancaria está inactiva!",
                icono: "error",
              });
              setIdCtaBan("");
              txtIdCuenta.current.value = "";
              txtNomBanco.current.value = "";
              txtNumCuenta.current.value = "";
              txtMontoDisponible.current.value = "";
              return;
            }
            txtIdCuenta.current.value = response.data.idcuentabancaria;
            txtNomBanco.current.value = response.data.nombre;
            txtNumCuenta.current.value = response.data.cuentabancaria;
            txtMontoDisponible.current.value = formatMoneda(
              response.data.saldolib
                .toString()
                .replace(",", "")
                .replace(".", ","),
              ",",
              ".",
              2
            );
            setIdCtaBan(txtIdCuenta.current.value);
            txtNumTransferencia.current.focus();
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Error.",
              texto: "¡La Cuenta no Existe!",
              icono: "error",
            });
            setIdCtaBan("");
            txtIdCuenta.current.value = "";
            txtNomBanco.current.value = "";
            txtNumCuenta.current.value = "";
            txtMontoDisponible.current.value = "";
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const seleccionarCuentaDestino = () => {
    let campos = "*";
    let nomtab = "debitocredito";
    let nomid = "idchequeemitido";
    let condic = "tipo = 17 AND fecha = '" + props.egreso[0].fechaemi + "'";
    let idche = props.egreso[0].idchequeemitido;

    let endpoint = `${op.conexion}/api/consulta/modelicondi?campos=${campos}&id=${idche}&nomtab=${nomtab}&nomid=${nomid}&condic=${condic}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data[0].idcuentabancaria > 0) {
            cmbCuentaBan.current.value = response.data[0].idcuentabancaria;
            txtNumReferencia.current.value = response.data[0].referencia;
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Error.",
              texto: "¡La Cuenta Destino no Existe!",
              icono: "error",
            });
            setIdCtaBan("");
            cmbCuentaBan.current.value = "0";
            txtNumReferencia.current.value = "";
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const handleProveedor = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    setHabiBot(true);
    txtCedurifprov.current.value = "";
    txtNombreprov.current.value = "";
    setData([]);
    setDatospre([]);
    setIdCtaBan("");
    setVisibleB("hidden");
    setHabiCtaDes(false);
    txtIdCuenta.current.value = "";
    txtNomBanco.current.value = "";
    txtNumCuenta.current.value = "";
    txtMontoDisponible.current.value = "";
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarProveedor(event.target.value, event.which);
      }
    }
  };

  const changeProveedor = (event) => {
    event.preventDefault();
    setHabiBot(true);
    txtCedurifprov.current.value = "";
    txtNombreprov.current.value = "";
    setData([]);
    setDatospre([]);
    setIdCtaBan("");
    setVisibleB("hidden");
    setHabiCtaDes(false);
    txtIdCuenta.current.value = "";
    txtNomBanco.current.value = "";
    txtNumCuenta.current.value = "";
    txtMontoDisponible.current.value = "";
  };

  const handleCuentaBancaria = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarCuentaBancaria(event.target.value);
      }
    }
  };

  const changeCuentaBancaria = (event) => {
    event.preventDefault();
    setIdCtaBan("");
    txtNomBanco.current.value = "";
    txtNumCuenta.current.value = "";
    txtMontoDisponible.current.value = "";
  };

  const catalogoProveedor = (e) => {
    e.preventDefault();
    setMostrar4(true);
  };

  const handleCancelaProveedor = () => {
    setMostrar4(false);
  };

  const handleAceptarProveedor = (
    responsable,
    razonsocial,
    idproveedor,
    rif
  ) => {
    setMostrar4(false);
    if (props.operacion === 1) {
      setHabiBot(false);
    } else {
      setHabiBot(true);
    }
    txtIdprov.current.value = idproveedor;
    txtCedurifprov.current.value = rif;
    txtNombreprov.current.value = razonsocial.trim();
  };

  const catalogoCuentaBancaria = (e) => {
    e.preventDefault();
    setMostrar5(true);
  };

  const handleCancelaCuentaBancaria = () => {
    setMostrar5(false);
  };

  const handleAceptarCuentaBancaria = (datos) => {
    setMostrar5(false);

    txtIdCuenta.current.value = datos.idcuentabancaria;
    txtNomBanco.current.value = datos.nombre;
    txtNumCuenta.current.value = datos.cuentabancaria;
    txtMontoDisponible.current.value = formatMoneda(
      datos.saldolib.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
    setIdCtaBan(txtIdCuenta.current.value);
  };

  const cargarConcepto = (data) => {
    var abon = "";
    var per = "";
    txtConcepto.current.value = "";
    if (data.length === 1) {
      if (parseFloat(data[0].montoabonado) > 0.0) {
        abon = " ABONO DE ";
      } else {
        abon = "";
      }
      txtConcepto.current.value =
        abon +
        "PAGO" +
        " DE LA ORDEN Nº " +
        (norden ? data[0].numordenpago : data[0].idordenpago) +
        " REFERENTE A " +
        data[0].concepto.trim();
    } else {
      for (let i = 0; i < data.length; i++) {
        let concepto = "Pago de Orden(es) de Pago(s) ";

        per = per + (norden ? data[i].numordenpago : data[i].idordenpago) + " ";
        //per = per + idOrden.get(i).toString() + " ";
        txtConcepto.current.value = concepto + per.trim();
      }
    }
  };

  const cambiarConcepto = () => {
    setDesde(0);
    setMostrarUsuario(true);
  };

  const cambiarFechaReverso = () => {
    setDesde(1);
    setMostrarUsuario(true);
  };

  const autorizarDesautorizarEliminacion = () => {
    setDesde(4);
    setMostrarUsuario(true);
  };
  const validarModificarFechaReverso = (fecha) => {
    let sigue = true;
    if (txtFechaReverso.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Seleccione la Fecha de Reverso",
        icono: "informacion",
      });
      sigue = false;
      txtFechaReverso.current.focus();
    } else if (txtMotivo.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Motivo de Reverso no debe estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtMotivo.current.focus();
    }
    if (sigue) {
      procesarCambioFechaReverso();
    }
  };

  const procesarCambioFechaReverso = () => {
    let body = {
      idegreso: txtCodigo.current.value,
      motivorev: txtMotivo.current.value.trim(),
      dfecha: txtFechaReverso.current.value,
      idcuentaban: txtIdCuenta.current.value,
      idefi: idefiscal,
      idusu: idusuario,
      fechasis: fechaSistema,
      dirip: ip === "" || ip === null ? "0.0.0.0" : ip,
      dirmac: mac === "" || mac === null ? "0.0.0.0" : mac,
    };

    let endpoint = `${op.conexion}/api/administracion/modificarfechareversoegreso`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto:
              "Se Generaron Cambios Satisfactoriamente en el egreso " +
              txtCodigo.current.value,
            icono: "exito",
          });
          setModifi1(true);
          setProce1(false);
          setHabiRev(true);
          setCambioDatos(true);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const aceptaClaveSupervisor = () => {
    setMostrarUsuario(false);
    if (desde === 0) {
      setModifi(false);
      setProce(true);
      setHabiFecha(false);
      setHabiConcep(false);
    } else if (desde === 1) {
      //setLlamado(3);
      setFecha(txtFechaReverso.current.value);
      setModifi1(false);
      setProce1(true);
      setHabiRev(false);
      //setMensaje({ mostrar: true, titulo: 'Notificación.', texto: 'El registro va a ser Modificado', icono: 'informacion' });
    } else if (desde === 4) {
      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto:
          "Se va " +
          (permiEliminar === 0 ? "Autorizar" : "Desautorizar") +
          " la eliminación del egreso \n Desea Continuar?",
        icono: "confirmacion",
      });
    } else if (desde === 5) {
      setModifi1(false);
      setProce1(true);
      setModifi(false);
      setProce(false);
      //setProce2(true);
    }
  };

  const validarModificarConcepto = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtCodigo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Código de la Orden de Pago no debe estar vacio.",
        icono: "informacion",
      });
      sigue = false;
      txtCodigo.current.focus();
    } else if (txtFecha.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Fecha",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (txtConcepto.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Concepto no debe estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtConcepto.current.focus();
    }

    if (sigue) {
      let body = {
        idegreso: txtCodigo.current.value,
        concepto: txtConcepto.current.value.trim(),
        dfecha: txtFecha.current.value,
        numdoc: txtNumTransferencia.current.value,
        idcuentaban: txtIdCuenta.current.value,
        idefi: idefiscal,
        idusu: idusuario,
        fechasis: fechaSistema,
        dirip: ip === "" || ip === null ? "0.0.0.0" : ip,
        dirmac: mac === "" || mac === null ? "0.0.0.0" : mac,
        clasegasto: cmbGasto.current ? cmbGasto.current.value : 0,
      };

      procesarCambio(body);
    }
  };

  const procesarCambio = (body) => {
    let endpoint = `${op.conexion}/api/administracion/modificarconceptoegreso`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto:
              "Se Generaron Cambios Satisfactoriamente en el egreso " +
              txtCodigo.current.value,
            icono: "exito",
          });
          setModifi(true);
          setProce(false);
          setHabiConcep(true);
          setHabiFecha(true);
          setCambioDatos(true);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const procesarCambioAutorizacion = () => {
    let valor = permiEliminar === 0 ? 1 : 0;
    let body = {
      idegreso: txtCodigo.current.value,
      valor: permiEliminar === 0 ? 1 : 0,
      idefiscal: idefiscal,
    };

    let endpoint = `${op.conexion}/api/administracion/autorizardesautorizareliminaregreso`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setCambioDatos(true);
          setPermiEliminar(valor);
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto:
              "Se " +
              (valor === 1 ? "Autorizó" : "Desautorizó") +
              " la elimización del Egreso",
            icono: "exito",
          });
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const imprimirEgreso = (idEgre) => {
    var reporte = "";
    reporte = "ForEgresoPagoNumOrden";

    var sql = idEgre;
    var sql2 = "TRASPASO BANCARIO";

    var monto = txtMontoPagar.current.value;
    var sql1 = numeroaLetra(monto.trim().replace(/\./g, "")) + " Bs.";
    console.log(sql1)
    window.open(
      op.reportes +
      "/administracionTesoreria?" +
      "reporte=" +
      reporte +
      "&ID=" +
      sql +
      "&ENLETRAS=" +
      sql1 +
      "&TIPO=" +
      sql2 +
      "&IDEFISCAL=" +
      idefiscal,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };


  useEffect(() => {
    const anioActual = new Date().getFullYear();
    const aniosParaLista = [];

    // Bucle para generar el año actual y los 5 anteriores
    for (let i = 0; i <= 5; i++) {
      const anioCalculado = anioActual - i;
      aniosParaLista.push({
        value: anioCalculado,
        label: anioCalculado.toString()
      });
    }

    setAnioOrdArr(aniosParaLista);

    // Establecemos por defecto el año actual en el estado 'anio'
    if (anio === 0 || anio.length === 0) {
      setAnio(anioActual);
    }
  }, []); // Se ejecuta una sola vez al cargar el componente


  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setPermiEliminar(
          props.operacion !== 1 ? props.egreso[0].permitireliminar : 0
        );
        setOperacion(props.operacion);
        setModifi(false);
        setModifi1(false);
        if (props.operacion !== 1) {
          if (props.operacion === 4 && props.egreso[0].reversado === 0) {
            setModifi(true);
          }
          if (props.operacion === 4 && props.egreso[0].reversado > 0) {
            setModifi1(true);
          }
          setHabiFecha(true);
          setHabiConcep(true);
          if (espiritu === 0) {
            let con = props.gastos.length;
            for (let i = 0; i < con; i++) {
              if (props.egreso[0].idclasegasto !== null) {
                if (
                  props.gastos[i].idclasegasto === props.egreso[0].idclasegasto
                ) {
                  cmbGasto.current.value = props.egreso[0].idclasegasto;
                  break;
                }
              } else {
                cmbGasto.current.value = "";
              }
            }
          }
          txtCodigo.current.value = props.egreso[0].idchequeemitido;
          txtFecha.current.value = moment.utc(props.egreso[0].fechaemi).format(
            "YYYY-MM-DD"
          );
          txtConcepto.current.value = props.egreso[0].concepto;
          txtIdCuenta.current.value = props.egreso[0].idcuentabancaria;
          txtNumTransferencia.current.value = props.egreso[0].numerocheque;
          seleccionarCuentaBancaria(props.egreso[0].idcuentabancaria);
          if (props.operacion === 2) {
            setHabiRev(false);
          } else {
            setHabiRev(true);
          }
          if (props.egreso[0].reversado > 0) {
            txtFechaReverso.current.value = moment.utc(
              props.egreso[0].fechareverso
            ).format("YYYY-MM-DD");
            txtMotivo.current.value = props.egreso[0].motivoreverso.trim();
          }
          var data = [...props.egresodetalle];
          var datos = [];
          txtIdprov.current.value =
            data[0].idproveedor === null
              ? data[0].idproveedororden
              : data[0].idproveedor;
          seleccionarProveedor(
            data[0].idproveedor === null
              ? data[0].idproveedororden
              : data[0].idproveedor
          );
          for (let i = 0; i < data.length; i++) {
            datos.push({
              numordenpago: data[i].numordenpago,
              razonsocial: data[i].razonsocial,
              concepto: data[i].concepto,
              idproveedor: data[i].idproveedororden,
              idordenpago: data[i].idordenpago,
              fecha: data[i].fecha,
              observaciones: data[i].observaciones,
              montoorden: data[i].montoordenpago,
              montoamortizado: data[i].montoamortizado,
              montoabonado: data[i].abonoafecha,
              montoretenido: data[i].retencion,
              montopagar: data[i].montoabono,
              tipoorden: data[i].tipo,
              claseorden: data[i].clase,
              idcuentabancaria: data[i].idcuentabancaria,
            });
          }
          setValida(1);
          const nanio = props.egreso[0].fechaemi.toString().substring(0, 4)
        
          setAnioOrd(nanio);
          cmbAnio.current.value = nanio;
          calcularTotales(datos);
          setHabiBot(true);
          setHabiCta(false);
          setDeshabilitado(true);
          if (parseInt(data[0].tipo) === 3 && parseInt(data[0].clase) === 0) {
            setVisibleB("visible");
            selectCuentaBanco();
            seleccionarCuentaDestino();
          }
          setData(datos);
          setDatospre(datos);
        } else {
          setHabiRev(true);
          var nanio = [];
          nanio.push({ anio: fechaSistema.substring(2, 4) });
          nanio.push({ anio: fechaSistema.substring(0, 4) });
          setAnioOrd(nanio);
          setHabiBot(true);
          setDeshabilitado(false);
          txtConcepto.current.value = "";
          txtFecha.current.value = moment.utc(fechaSistema).format("YYYY-MM-DD");
          txtCodigo.current.value = "";
          setHabiConcep(false);
          setHabiFecha(false);
        }
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2">
        <h3 className="fs-4 m-0 fw-bold">
          {operacion === 1
            ? "Registrar Egreso"
            : operacion === 2
              ? "Reversar Egreso"
              : operacion === 3
                ? "Eliminar Egreso"
                : "Consultar Egreso"}
        </h3>
        <a
          type="button"
          className="fs-6 fw-bold text-light bg-transparent"
          onClick={cancelar}
        >
          salir<i className="fa fa-times ml-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <Dimmer active={activate}></Dimmer>
        <div className=" mx-auto row col-md-12 rounded p-1">
          <input type="hidden" ref={txtNp} />
          <fieldset className="col-12 m-0 p-2 d-flex flex-wrap align-items-center border-table rounded m-0 ">
            <legend className="float-none m-0 w-auto fs-6 fw-bold">
              Datos
            </legend>
            {props.egreso && props.egreso[0].reversado > 0 && (
              <div className="col-sm-12">
                <div className="input-group input-group-sm m-0 w-100">
                  <font color="red" size="1">
                    <h1 align="center">
                      <i>¡ El Egreso está Reversado !</i>
                    </h1>
                  </font>
                </div>
              </div>
            )}
            <div className="col-12 d-flex m-0 p-0">
              <div className="col-4 col-lg-2 m-0 mb-2 mb-lg-0 p-0">
                <Input
                  label="Código:"
                  name="observacion"
                  disabled={true}
                  defaultValue={
                    props.aprobaciones
                      ? props.aprobaciones.idaprobaciones.trim()
                      : ""
                  }
                  id="inputDireccion"
                  ref={txtCodigo}
                />
              </div>
              <div className="col-6 col-lg-2 m-0 ml-auto p-0 pl-2">
                <Input
                  label="Fecha:"
                  type="date"
                  disabled={habiFecha}
                  defaultValue={
                    props.egreso && props.egreso[0].fechaemi !== ""
                      ? moment.utc(props.egreso[0].fechaemi).format("YYYY-MM-DD")
                      : moment.utc(fechaSistema).format("YYYY-MM-DD")
                  }
                  id="inputDireccion"
                  ref={txtFecha}
                />
              </div>
              <div className="col-6 col-lg-2 m-0 p-0 pl-2">
                <Select
                  label="Año:"
                  name="idestado"
                  disabled={
                    operacion === 4 || operacion === 2 || operacion === 3
                      ? true
                      : deshabilitado
                  }
                  id="inputFechaReg"
                  ref={cmbAnio}
                  options={anioOrdArr}
                />
              </div>
            </div>

            <div className="col-12 col-lg-12 mx-auto px-0 ">
              <fieldset className="col-12 m-0 p-2 row border-table rounded d-flex flex-wrap gap-2">
                <legend className="float-none m-0 w-auto fs-6 fw-bold">
                  Proveedor/Beneficiario
                </legend>
                <div className="col-md-12 row mx-auto px-0">
                  <div className="col-2 m-0 p-0">
                    <SearchInput
                      label="Código:"
                      autoComplete="off"
                      onChange={handleProveedor}
                      onKeyUp={handleInputNumChange}
                      //onBlur={handleInputNumChange}
                      disabled={
                        operacion === 4 || operacion === 2 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      id="idprov"
                      ref={txtIdprov}
                      disabledButton={
                        operacion === 4 || operacion === 2 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      onClickButton={catalogoProveedor}
                    />
                  </div>

                  <div className="col-7 m-0 p-0">
                    <Input
                      label="Nombre:"
                      ref={txtNombreprov}
                      disabled={true}
                      id="inputDireccion"
                    />
                  </div>

                  <div className="col-3 m-0 p-0">
                    <Input
                      label="RIF:"
                      maxLength={12}
                      disabled={true}
                      ref={txtCedurifprov}
                    />
                  </div>
                </div>
              </fieldset>
            </div>

            <div className="col-12 p-0 m-0 my-2">
              <TablaListEgresos
                data={BaseDatos}
                datarecords={datospre}
                operacion={operacion}
                habibot={habiBot}
                idproveedor={txtIdprov.current ? txtIdprov.current.value : ""}
                idcuentabancaria={idCtaBan}
              />
            </div>
            <div className="col-12 m-0 p-0 d-flex align-items-center gap-2">
              <Textarea
                label="Concepto:"
                disabled={habiConcep}
                style={{ height: 70 }}
                name="observacion"
                onChange={onChange}
                defaultValue={
                  props.aprobaciones
                    ? props.aprobaciones.observaciones.trim()
                    : ""
                }
                placeholder="Descripción del Concepto"
                id="inputDireccion"
                ref={txtConcepto}
              />
              {modifi === true && (
                <WarningButton
                  onClick={cambiarConcepto}
                  icon="fa-edit m-0"
                ></WarningButton>
              )}
              {proce === true && (
                <SuccessButton
                  onClick={validarModificarConcepto}
                  icon="fa-check-circle m-0"
                ></SuccessButton>
              )}
            </div>
          </fieldset>
          <fieldset className="col-12 m-0 my-2 p-2 border-table rounded ">
            <legend className="float-none m-0 w-auto fs-6 fw-bold">
              Datos Cuenta Bancaria
            </legend>

            <div className="col-12 m-0 p-0 d-flex flex-wrap justify-content-between align-items-center">
              <div className=" col-4 col-lg-3 p-0 m-0 mb-1">
                <SearchInput
                  label="Código:"
                  autoComplete="off"
                  disabled={!habiCta}
                  onChange={changeCuentaBancaria}
                  onKeyUp={handleCuentaBancaria}
                  onBlur={handleInputNumChange}
                  id="idcuenta"
                  ref={txtIdCuenta}
                  onClickButton={catalogoCuentaBancaria}
                  disabledButton={!habiCta}
                />
              </div>
              <div className="col-12 col-lg-6 p-0 m-0 mb-1">
                <Input
                  label="Banco:"
                  disabled={true}
                  id="inputDireccion"
                  ref={txtNomBanco}
                />
              </div>
              <div className="col-12 col-lg-6 p-0 m-0 mb-1">
                <Input
                  label="N°-Cuenta:"
                  disabled={true}
                  id="inputDireccion"
                  ref={txtNumCuenta}
                />
              </div>
              <div className="col-12 col-lg-6 p-0 m-0 mb-1">
                <Input
                  label="N° de Transferencia:"
                  autoComplete="off"
                  disabled={habiFecha}
                  onKeyUp={handleInputNumChange}
                  id="numtransferencia"
                  ref={txtNumTransferencia}
                />
              </div>
              <div className="col-12 col-lg-6 p-0 m-0 mb-1">
                <Input
                  label="Monto Disponible de la Cuenta Bancaria:"
                  disabled={true}
                  id="inputDireccion"
                  ref={txtMontoDisponible}
                />

              </div>
              <div className="col-12 row col-lg-3 rounded border-table p-0 m-0 mb-1">
                <div className="col fw-bold">
                  Tipo de Pago
                </div>
                <div className="col">
                  <Radio
                    label="Transferencia"
                    defaultChecked={true}
                    name="exampleRadios"
                    id="exampleRadios2"
                    value="option2"
                  />
                </div>
              </div>
            </div>

            {/* TODO - CAMBIAR ESTo A !visibleB */}
            {visibleB === "visible" && (
              <div className="col-12 m-0 mt-2 p-0 d-flex justify-content-between align-items-center">
                <div className="col-12 col-lg-6 p-0 m-0">
                  <Select
                    label="Cuenta Destino:"
                    name=""
                    disabled={!habiCtaDes}
                    ref={cmbCuentaBan}
                    options={cuentaBancaria}
                  />
                </div>
                <div className="col-lg-3 m-0 p-0">
                  <Input label="N° Referencia:"
                    autoComplete="off"
                    disabled={!habiCtaDes}
                    onKeyUp={handleInputNumChange}
                    id="numReferencia"
                    ref={txtNumReferencia}
                  />
                </div>
              </div>
            )}
          </fieldset>

          <div className="col-md-12 m-0 p-0 d-flex flex-wrap">
            <div className="col-12 m-0 p-0">
              {espiritu === 0 &&
                <div className="col-12 input-group input-group-sm m-0 p-0">
                  <label className="input-group-text fw-bold">
                    Tipo de Gasto:
                  </label>
                  <select class="form-select" ref={cmbGasto} disabled={habiFecha}>
                    {props.gastos &&
                      props.gastos.map((item, index) => (
                        <option key={index} value={item.idclasegasto}>
                          {" "}
                          {item.descripcion}{" "}
                        </option>
                      ))}
                  </select>
                </div>
              }
              <div className="col-12 m-0 p-0 d-flex flex-wrap">
                {((props.egreso && props.egreso[0].reversado > 0) ||
                  props.operacion === 2) &&
                  <div className="input-group input-group-sm col-4 col-lg2 m-0 p-0">
                    <label className="input-group-text">Fecha Reverso:</label>
                    <input
                      type="date"
                      className="form-control text-uppercase"
                      disabled={habiRev}
                      ref={txtFechaReverso}
                      defaultValue={
                        props.egreso &&
                          props.egreso[0].fechareverso !== "" &&
                          props.egreso[0].fechareverso !== null
                          ? moment.utc(props.egreso[0].fechareverso).format(
                            "YYYY-MM-DD"
                          )
                          : moment.utc(fechaSistema).format("YYYY-MM-DD")
                      }
                      id="inputDireccion"
                    />
                    {modifi1 === true &&
                      <button
                        onClick={cambiarFechaReverso}
                        className="btn btn-sm mx-1 btn-warning rounded"
                      >
                        <i className="fas fa-edit"></i>
                      </button>
                    }
                    {proce1 === true &&
                      <button
                        type="button"
                        onClick={validarModificarFechaReverso}
                        className="btn btn-success rounded fw-bold"
                      >
                        <i className="far fa-check-circle"></i>
                      </button>
                    }
                  </div>
                }

                {((props.egreso && props.egreso[0].reversado > 0) ||
                  props.operacion === 2) &&
                  <div className="col-12 input-group input-group-sm p-0 m-0">
                    <label className="input-group-text">
                      Motivo del Reverso:
                    </label>
                    <textarea
                      type="textarea"
                      disabled={habiRev}
                      style={{ height: 70 }}
                      className="form-control text-uppercase"
                      name="observacion"
                      onChange={onChange}
                      ref={txtMotivo}
                      placeholder="Descripción del Concepto"
                      id="inputMotivo"
                    />
                  </div>
                }
              </div>
            </div>
            <div className="col-md-12 col-lg-12 col-xl-12  row mx-auto px-0">
              <div className="col-md-3 m-0 p-0 pr-2">
                <Input label="Monto de Pago:"
                  disabled={true}
                  ref={txtMontoPago}
                  placeholder="0,00"
                  id="inputDireccion"
                />
              </div>
              <div className="col-md-3 m-0 p-0 pr-2">
                <Input label="Monto Retenciones:"
                  disabled={true}
                  ref={txtMontoRetenciones}
                  placeholder="0,00"
                  id="inputDireccion"
                />
              </div>
              <div className="col-md-3 m-0 p-0 pr-2">
                <Input label="Monto Amortizado:"
                  disabled={true}
                  ref={txtMontoAmortizado}
                  placeholder="0,00"
                  id="inputDireccion"
                />
              </div>
              <div className="col-md-3 m-0 p-0 pr-2">
                <Input label="Monto a Pagar:"
                  disabled={true}
                  ref={txtMontoPagar}
                  placeholder="0,00"
                  id="inputDireccion"
                />
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          ref={btnAcepta}
          onClick={onChangeValidar}
          disabled={props.operacion === 4 ? true : false}
        >
          Aceptar
        </SuccessButton>
        <DangerButton onClick={cancelar}> Cancelar </DangerButton>

        {props.egreso && props.operacion !== 1 &&
          <InfoButton
            onClick={() =>
              imprimirEgreso(txtCodigo.current ? txtCodigo.current.value : 0)
            }
            icon="fa-print"
          >
            Imprimir
          </InfoButton>
        }
        {(props.egreso && props.operacion === 4 && props.egreso[0].reversado > 0) &&
          <WarningButton onClick={autorizarDesautorizarEliminacion}>
            {(permiEliminar === 0 ? "Autorizar" : "Desautorizar") + " Eliminación de Egreso"}
          </WarningButton>
        }
      </Modal.Footer>
      <CatalogoProveedorPresupuesto
        show={mostrar4}
        onHideCancelar={handleCancelaProveedor}
        onHideAceptaProveedor={handleAceptarProveedor}
      />
      <CatalogoCuentaBancaria
        show={mostrar5}
        onHideCancelar={handleCancelaCuentaBancaria}
        onHideAceptaCatalogo={handleAceptarCuentaBancaria}
      />
      <ValidarUsuario
        show={mostrarUsuario}
        onHideCancela={() => {
          setMostrarUsuario(false);
          setDesde(0);
        }}
        onHideConfirmar={aceptaClaveSupervisor}
        llamado={0}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito." ? cerrarModal() : cerrarMensaje();
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() => {
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
          if (desde === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "El Egreso Nª" + idCheemi + " fué Registrado Correctamente",
              icono: "exito",
            });
          }
        }}
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};
